module.exports = __webpack_public_path__ + "static/media/fallback.de270fd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fallback.png
// module id = 2281
// module chunks = 0